import type { ToolDefinition } from "@arcadeai/arcadejs/resources/index.mjs";
import type { ToolkitCollection } from "@arcadeai/ui-kit/arcade/arcade";
import { buildToolkitCollection } from "@arcadeai/ui-kit/arcade/toolkit-collection";
import { toolkitCollectionKeys } from "@arcadeai/ui-kit/hooks/query-keys";
import { filterHiddenToolkits } from "@arcadeai/ui-kit/utils/filter-hidden-toolkits";
import { queryOptions } from "@tanstack/react-query";
import { getEngineApi } from "@/lib/api";
import { HIDDEN_TOOLKITS } from "@/lib/const";
import type { OrgProjectScope } from "@/lib/resource-context";

const selectFilteredToolkits = (data: ToolkitCollection) =>
  filterHiddenToolkits(data, HIDDEN_TOOLKITS);

export const toolkitCollectionQueryOptions = (scope: OrgProjectScope) => {
  const { organizationId, projectId } = scope;

  return queryOptions<ToolkitCollection>({
    queryKey: toolkitCollectionKeys.collection({
      ...(organizationId && { organizationId }),
      ...(projectId && { projectId }),
    }),
    queryFn: async () => {
      const client = getEngineApi(scope);
      const { data } = await client.get<{ items: ToolDefinition[] }>("/tools", {
        params: { limit: 25_000 },
      });
      return buildToolkitCollection(data.items);
    },
    select: selectFilteredToolkits,
  });
};
